import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { IParentChild } from '@/types/parent';
import { createEncryptedStorage } from '@/utils/encryption';

type TParentStore = {
  children: IParentChild[];
  selectedChild: IParentChild | null;
  setChildren: (children: IParentChild[]) => void;
  setSelectedChild: (child: IParentChild | null) => void;
  reset: () => void;
};

export const useParentStore = create<TParentStore>()(
  persist(
    (set) => ({
      children: [],
      selectedChild: null,

      setChildren: (children) =>
        set((state) => {
          // If no selectedChild yet and children exist, auto-select first
          if (!state.selectedChild && children.length > 0) {
            return { children, selectedChild: children[0] };
          }

          // If current selectedChild is no longer in the list, reset to first
          if (
            state.selectedChild &&
            !children.some((c) => c.id === state.selectedChild!.id)
          ) {
            return { children, selectedChild: children[0] ?? null };
          }

          return { children };
        }),

      setSelectedChild: (child) => set({ selectedChild: child }),

      reset: () => set({ children: [], selectedChild: null }),
    }),
    {
      name: 'parent-store',
      storage: createEncryptedStorage<TParentStore>(),
    }
  )
);
